import React, { useEffect, useState } from 'react';
import WbIdleModal from './WbIdleModal';
import { useDispatch, useSelector } from 'react-redux';
import { useIdleTimer } from 'react-idle-timer';
import { logout } from '@sonifi/wb-login/services/keyMaster.service';
import { useNavigate } from 'react-router';

const timeout = 3600_000;
const promptBeforeIdle = 60_000;

const WbIdle = () => {
  const usesSSO = useSelector((state) => state.user.usesSSO);
  const authenticated = useSelector((state) => state.user.authenticated);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [remaining, setRemaining] = useState(timeout);
  const [open, setOpen] = useState(false);

  const onIdle = async () => {
    setOpen(false);
    await dispatch(logout({ usesSSO }));
    navigate('/', { replace: true });
  };

  const onActive = () => {
    setOpen(false);
  };

  const onPrompt = () => {
    if (authenticated) {
      setOpen(true);
    }
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime]);

  const handleStillHere = () => {
    activate();
  };

  return (
    <WbIdleModal
      open={open}
      onCancel={handleStillHere}
      remainingTime={remaining}
    />
  );
};

export default WbIdle;
